export const VIDEO_BANNER_WRAPPER_CLASS = 'video-banner__wrapper'
